/* .serviceList__item */

export module ServiceListItemModule {
  export class Service {
    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.setEvent();
      });
    }

    public static setEvent() {
      const $elements = document.querySelectorAll('.serviceList__item');
      if ($elements) {
        $elements.forEach($element => {
          const $image = $element.querySelector('.serviceList__itemFlexImage');
          if ($image) {
            $element.classList.add('serviceList__item--isImage');
          }
        });
      }
    }
  }
}